"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports.commonListingTranslations = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
/**
 * Given certain text and object of values, it replaces where the values are found in the text
 * @param {string} text - string containing text and keys to be translated
 * @param {object} translationValues - object which keys are replaced in the result text by the values
 */
var translate = function translate(text) {
  var translationValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var replacedText = text;
  for (var _i = 0, _Object$entries = Object.entries(translationValues); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      val = _Object$entries$_i[1];
    replacedText = replacedText.replace("{".concat(key, "}"), val.toString());
  }
  return replacedText;
};
exports.translate = translate;
var commonListingTranslations = {
  appliedFilters: 'Applied Filters:',
  changeFilterCriteria: 'Try changing or broadening your filter criteria.',
  dateRangeEnd: 'Date Range End',
  dateRangeStart: 'Date Range Start',
  deselectAllFilters: 'Deselect All',
  done: 'Done',
  facetLanguages: 'Languages',
  facetRegion: 'Region',
  facetTopic: 'Topics',
  filterAndSort: 'Filter & sort',
  filters: 'Filters',
  learnMore: 'Learn More',
  noSearchResults: 'No search results',
  selectAllFilters: 'Select All',
  selectDate: 'Select Date',
  today: 'Today',
  uncheckAll: 'Uncheck All',
  page: 'Page',
  pagination: 'Showing {pageStart} - {pageEnd} of {numberOfPages} Results'
};
exports.commonListingTranslations = commonListingTranslations;